import {
  Layout,
  //Sliders,
  //Users,
  Settings,
} from "react-feather";

// const role = localStorage.getItem("atur");
// console.log("role == ", role);

var pagesSection = [];

pagesSection = [
  {
    href: "/chat",
    icon: Layout,
  },
  // {
  //   href: "/contact",
  //   icon: Users,
  // },
  {
    href: "/settings",
    icon: Settings,
  },
];

const navItems = [
  {
    // title: "Pages",
    pages: pagesSection,
  },
];

export default navItems;
